require('../../modules/es6.number.is-finite');
module.exports = require('../../modules/_core').Number.isFinite;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/number/is-finite.js
// module id = 122
// module chunks = 0